import { Grid, GridColumn } from "semantic-ui-react";

import { ResetFiltersButton } from "components";
import { LocationDropdown } from "modules/LocationLicenseOverview/components/LocationLicenseFilters/components";
import { useResetLocationLicensesDashboardFilters } from "modules/LocationLicenseOverview/components/LocationLicenseFilters/hooks";

export const LocationLicenseOverviewFilters = () => {
  const { handleResetLocationLicensesDashboardFilters } = useResetLocationLicensesDashboardFilters();

  return (
    <div className="filters">
      <Grid className="grid">
        <GridColumn width={5} className="no-left-gutter">
          <LocationDropdown />
        </GridColumn>
        <GridColumn floated="right">
          <div className="reset-button-container">
            <ResetFiltersButton handleReset={() => handleResetLocationLicensesDashboardFilters()} />
          </div>
        </GridColumn>
      </Grid>
    </div>
  );
};
